module.exports = __webpack_public_path__ + "img/t1-16.b1780438.png";